import {
    CREATE_PROPERTYGROUP,
    CREATE_PROPERTYGROUP_FAILURE,

    CREATE_PROPERTYGROUP_LOCALISATION,
    CREATE_PROPERTYGROUP_LOCALISATION_FAILURE,
    CREATE_PROPERTYGROUP_LOCALISATION_SUCCESS,
} from 'store/actions/types';

export const createPropertygroup = (payload) => {
    return {
        type: CREATE_PROPERTYGROUP,
        payload: payload,
    };
};

export const createPropertygroupFailure = (error) => {
    return {
        type: CREATE_PROPERTYGROUP_FAILURE,
        error: error,
    };
};

export const createPropertygroupLocalisation = (payload, response) => {
    return {
        type: CREATE_PROPERTYGROUP_LOCALISATION,
        payload: payload,
        response: response,
    };
};

export const createPropertygroupLocalisationFailure = (error) => {
    return {
        type: CREATE_PROPERTYGROUP_LOCALISATION_FAILURE,
        error: error,
    };
};

export const createPropertygroupLocalisationSuccess = (payload, response) => {
    return {
        type: CREATE_PROPERTYGROUP_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/propertygroups/createPropertygroups.js